import { render } from "./ModulePage.vue?vue&type=template&id=57015f7d"
import script from "./ModulePage.vue?vue&type=script&lang=js"
export * from "./ModulePage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__